<template>
  <div class="index">
    <crumbs>
      <i class="icon-stack2"></i>
      <span class="text">{{multiLanguage.crumbs.userList}}</span>
    </crumbs>
    <div class="content">
      <div class="panel">
        <mtable v-if="trData"
          :thData="thData"
          :trData="trData"
          :multiLanguage="multiLanguage"
          :selPage="selPage"
          :seekDropdown="seekDropdown"
          :page="page"
          :jsonExcelAjax="jsonExcelAjax"
          :handle="handle"
          :sort="sort"
          @seek="tableAjax"
          @tableChange="tableAjax"
          @deleteList="deleteList">
        </mtable>
      </div>
    </div>
  </div>
</template>

<script>
  import  { URL_USERLIST,URL_USERDELETE } from 'api/api.js'
  import crumbs from "components/crumbs"
  import mtable from "components/mtable"

  export default {
    name: "userList",
    mixins: [
      require("common/mixin/base.js").base({multiLanguage:"tableModelUserList"})
    ],
    data () {
      return {
        trData: "", //  表格tr数据 
        sort: {  // 排序
          key: "user_id",
          method: "ASC"
        },
        handle: {  //  操作中间几个按钮
          link: "userDatum",  // 跳转路由
          idKey: "user_id",  // 跳转路由传id的key值
          delete: true,  // 设置有删除功能
          deleteUrl: URL_USERDELETE,  // 删除接口
          deleteKey: "user_id"  // 删除接口查询的key值
        },
        seekDropdown: {  // 搜索选项
          list: {
            loginId: "user_id",
            userName: "user_name",
            phone: "phone",
            email: "email"
          },
          active: 'loginId',
          seekStr: ""
        },
        page: {  // 分页
          active: 1,
          pageLeng: 0,
          offset: 0
        },
        selPage: {  //  配合分页的显示col数目选择
          list: [5, 10, 25, 50],
          active: localStorage.pageMaxIndex,
          limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
        }
      }
    },
    mounted () {
      this.seekDropdown && (this.seekDropdown.seekStr = "")
      this.tableAjax()
    },
    computed: {
      thData() {  // 表格th数据
        return [this.multiLanguage.th.loginId,this.multiLanguage.th.accountName,this.multiLanguage.th.phone,this.multiLanguage.th.email,this.multiLanguage.th.remark]
      },
      jsonExcelAjax () {
        return {
          url: URL_USERLIST,
          ajaxType: "get",
          getKey: ["data", "data", "rows"],
          ajaxPar: {
            limit: this.$ALLNUM,
            offset: 0,
            sort: this.sort.method,
            sortKey: this.sort.key,
            seekKey: this.seekDropdown.list[this.seekDropdown.active],
            seekVal: this.seekDropdown.seekStr
          }
        }
      }
    },
    methods: {
      tableAjax() {
        let offset = this.page.offset
        let limit = this.selPage.limit
        let sortKey = this.sort.key
        let sort = this.sort.method
        let seekKey = this.seekDropdown.list[this.seekDropdown.active]
        let seekVal = this.seekDropdown.seekStr

        this.$http(URL_USERLIST,{
          params: {limit, offset, sortKey, sort, seekKey, seekVal}
        }).then((res) => {
          let data = res.data.data
          this.trData = data.rows
          this.page.pageLeng = data.count
        })
      },
      deleteList (list) { // 删除事件
        this.$http.post(this.handle.deleteUrl, {
          sortKey: this.handle.deleteKey,
          removeList: list
        }).then(res => {
          if (this.page) this.page.active = 1
          if (this.seekDropdown) this.seekDropdown.seekStr = ""
          this.tableAjax()
        })
      }
    },
    components: {
      mtable,
      crumbs
    }
  }
</script>

<style lang="scss" type="text/scss">

</style>



// WEBPACK FOOTER //
// userList.vue?d392ed1e